import LoginContainer from './LoginContainer';

export default { LoginContainer };
